import { pickBy } from '@/utils'
import AttrGoods from './attr-goods'
import CompPickerLink from '../../comps/comp-pickerLink'

export default {
  name: 'WgtJnBillionCard',
  setting: [
    { label: '百亿标题', key: 'byTitle', component: 'input', value: '百亿补贴' },
    { label: '百亿副标题', key: 'bySubtitle', component: 'input', value: '加码疯抢' },
    { label: '买赠标题', key: 'zsTitle', component: 'input', value: '买即赠' },
    { label: '买赠副标题', key: 'zsSubtitle', component: 'input', value: '更划算' }
  ],
  transformIn: (v) => {
    const { name, base } = v

    return {
      name,
      ...base
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          byTitle: 'byTitle',
          bySubtitle: 'bySubtitle',
          zsTitle: 'zsTitle',
          zsSubtitle: 'zsSubtitle'
        })
      },
      data: []
    })
  }
}
